import { render, staticRenderFns } from "./SelectExercise.vue?vue&type=template&id=39e7b4f1"
import script from "./SelectExercise.vue?vue&type=script&lang=js"
export * from "./SelectExercise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports